import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import NouveauDossier from "@/pages/NouveauDossier";
import DossierDetail from "@/pages/DossierDetail";
import PromptsIa from "@/pages/PromptsIa";
import PortailClient from "@/pages/PortailClient";
import ClientPrevisionnel from "@/pages/ClientPrevisionnel";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/portail/:token" element={<PortailClient />} />
                        <Route path="/client/:token/previsionnel" element={<ClientPrevisionnel />} />
                        <Route element={<ProtectedRoute />}>
                            <Route element={<DashboardLayout />}>
                                <Route path="/dashboard" element={<Dashboard />} />
                                <Route path="/nouveau-dossier" element={<NouveauDossier />} />
                                <Route path="/dossiers/:id" element={<DossierDetail />} />
                                <Route path="/prompts-ia" element={<PromptsIa />} />
                            </Route>
                        </Route>
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="top-right" />
        </div>
    );
}

export default App;
